'use client'    
import { ReactNode, useState } from 'react';
import Form from 'react-bootstrap/Form';

const WGPUConfig = (props: any):ReactNode =>{

    const shadowmapsST = localStorage.getItem('shadowmaps'); 
    const shadowmaps = shadowmapsST !== null ? parseInt(shadowmapsST)> 0 : false; 

    const [s, ss]=useState<boolean>(shadowmaps)

    return (
        <div>
         <Form className='engine-config' id="webgpu-config">
        <Form.Check // prettier-ignore
                onChange={(e:any) => {
                   localStorage.setItem('shadowmaps', e.target.checked); ss(e.target.checked); }
                   
                }
                checked = {s}
                type="switch"
                
                id="webgpu-shadow"
                label="shadowmaps"
                />
            </Form>
        </div>
    );
}
export default WGPUConfig;
